module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "hgroup"
  }, [_c('h2', [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('i', {
    staticStyle: {
      "font-size": "1em",
      "line-height": "1.5",
      "text-indent": "1.5em"
    }
  }, [_vm._v("La Noche")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "1em",
      "line-height": "1.5",
      "text-indent": "1.5em"
    }
  }, [_vm._v("looked out over the Golden Gate toward Marin County. It was one of the big, old-fashioned mansions that still survive in San Francisco, and it stood sedately in well-kept grounds surrounded by an iron fence. Downstairs, there was an excellent restaurant opening off the bar. Upstairs was the casino.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray went into the bar. Even this early, it was beginning to be crowded. Gray wandered back between the booths and the bar until he saw Zucker, down at the end, perched bulkily on a bar-stool, a highball glass almost lost in one big hand.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Not in uniform, I see,” Gray said, sliding in beside the detective.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Off duty,” Zucker grunted. “What took you so long?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That’s what you get for hanging up on me.” Gray ordered Haig & Haig and soda. Zucker shook his head and nursed his drink. The hum of voices and the soft clinking of glasses seemed to muffle sounds in the long, dim-lit bar, but Zucker lowered his own voice when he spoke again.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You’re a cagey bastard, Mike,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Sure I am. What have I done now?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That woman we were talking about at lunch. Eleanor Pope, the one who got mugged a couple of blocks from here. Remember?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray took a drink and looked thoughtfully across the bar at the rows of bottles.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“So?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Why didn’t you tell me her brother-in-law was a patient of yours?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray said nothing. Zucker turned on the stool to face the analyst.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’m talking about Howard Dunne. How about it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray said slowly, “I’m not on the witness stand, Harry. Even if I were, there are things I can’t talk about.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Zucker swore under his breath.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Then listen to this,” he said. “We’ve just found Eleanor Pope’s purse. You know that little park where she was killed? The purse was buried in a flower bed there. A gardener found it when he was doing some planting yesterday. Well—as near as we can tell, nothing was stolen from the purse.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Was there anything worth stealing?” Gray asked. “I thought she went broke at the casino that night.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“She had about twenty bucks in bills and change in her purse,” Zucker said. “It’s still there. And a cigarette lighter worth about fifty, and a cigarette case that cost three times that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Then the motive wasn’t robbery.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“No. It was just meant to "), _c('i', [_vm._v("look")]), _vm._v(" like robbery. So it’s a new lead. That’s why I ordered another check on the people who’d been involved. Including Sam Pope. He’s the one who told me Howard Dunne’s one of your patients. All I want is for you to pass along to me anything that ties in with Eleanor Pope’s killing. Now wait a minute. I know all about the professional confidence angle. But this is murder. If Dunne tells you anything that can help clear up this case, I want you to report it to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Oh, you do, do you?” Gray said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Zucker flushed.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You’re a citizen as well as a psychoanalyst,” he said. “Don’t forget that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray waited a moment.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Listen, Harry,” he said. “Anything a patient tells me during analysis stays confidential. That’s one rule that can’t be broken. Because if it is—how can the patient trust the analyst?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“But I’m not asking for any confidential—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’ve never double-crossed a patient yet,” Gray said, his voice tightly controlled. “And I’m not going to start now. Or ever.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Damn it, Mike! Suppose Dunne gives you a lead to who the killer was? Are you going to hold out on me then?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray said, “Let’s keep it hypothetical. In a case like that, I’d certainly advise my patient to go to you and pass along the information. But my patient’s health comes first That’s the way it has to be.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Wait a minute,” Zucker said, and moved his head slightly. “Take a look up front.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray did. A man and woman were entering the bar. The woman was young and slim, with a small hat perched on loosely curling dark hair. Her lips were parted slightly. Gray recognized Mary Dunne.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The tall, lean man with her had smooth yellow hair and moved with easy assurance. His hand was under Mary Dunne’s arm. He guided her around the corner of the bar toward a booth.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Arnold Farragut,” Zucker said softly. “The oddball. Remember?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“The one you said spends more than he makes?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yeah. And he was here the night Eleanor Pope was killed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Is this why you wanted me to meet you here?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“One reason,” Zucker said. “We found out he’s been coming here with Mary Dunne a lot. I thought you might like to know. It might help, with that hypothetical patient of yours that I know God damned well is Howard Dunne. Listen.” Zucker finished his drink. “Farragut knew Eleanor Pope. Now he’s pretty thick with Mary Dunne. I don’t know what you may have found out, but I’m wondering about a blackmail angle.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That’s news to me,” Gray said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Maybe. Okay? Let’s go. Out this way.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("They left the bar by another door, to avoid Mary Dunne and Arnold Farragut. As they crossed a lobby, a man came quickly through the outer door and almost bumped into Zucker. The big detective moved aside, and only Gray saw his sudden alertness, the quick readiness of a matador in the arena.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Then Gray knew why that thought had come to him He knew, as he recognized the cold, lined face, the heavy eyes, and the bull shoulders with their unpleasant suggestion of deformity. He recognized the man. He had already seen him, beyond a closing door, in Maurice Hoyle’s office.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Hello, Oliver,” Zucker said, his eyes steady on the other man.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The sluggish voice was familiar, too.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You’re out of your class, Zucker. You can’t afford to buy drinks around here—unless you’ve started to get smart.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This must be Bruce Oliver, the man Zucker had called an errand boy—and a killer.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Zucker said, “I’ll see you around. Come on, Mike.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The cold eyes slid toward Gray.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yeah,” Oliver said. “Maybe. Maybe I’ll be seeing "), _c('i', [_vm._v("you")]), _vm._v(" around.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray knew that the man was talking to him.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa3be3e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/14_chapter10.vue
// module id = 102
// module chunks = 0